import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import "./i18n";
import store, {sagaMiddleware} from "./store";
import {Provider} from "react-redux";
import saga from "./sagas";

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
sagaMiddleware.run(saga)
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <App/>
        </Provider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
